'use strict';

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else element.className = element.className.replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/class/removeClass.js
 ** module id = 739
 ** module chunks = 0
 **/